import { loginAffiliateAuthentication } from "../../lib/loginAffiliateAuthentication";
import { loginAuthentication } from "../../lib/loginAuthentication";

import {
  formatError,
  runLogoutTimer,
  saveTokenAffiliateInLocalStorage,
  saveTokenInLocalStorage,
  signUp,
} from "../../services/AuthService";

export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";

export function signupAction(email, password, navigate) {
  return async (dispatch) => {
    try {
      const response = await signUp(email, password);
      saveTokenInLocalStorage(response.data);
      runLogoutTimer(dispatch, response.data.expiresIn * 1000);
      dispatch(confirmedSignupAction(response.data));
      navigate("/dashboard");
    } catch (error) {
      const errorMessage = formatError(error.response.data);
      dispatch(signupFailedAction(errorMessage));
    }
  };
}

export function Logout(navigate) {
  localStorage.removeItem("userDetails");
  navigate("/login");

  return {
    type: LOGOUT_ACTION,
  };
}

export function LogoutAffiliate(navigate) {
  localStorage.removeItem("userDetailsAfiliate");
  navigate("/afiliado/login");
  return {
    type: LOGOUT_ACTION,
  };
}
// Session length for company users (must match runLogoutTimer duration)
const COMPANY_SESSION_SECONDS = 10 * 60 * 60;
// Server issues 5h JWT for affiliates (employeeService.js)
const AFFILIATE_JWT_SECONDS = 5 * 60 * 60;

export function loginAction(email, password, navigate) {
  return async (dispatch) => {
    try {
      const response = await loginAuthentication({ email, password });
      const { data } = response;
      const { user } = data;

      if (data.status) {
        const { password: _omit, ...userSafe } = user || {};
        // Keep same shape as before (fields at root) for components reading localStorage
        const sessionPayload = {
          email,
          ...userSafe,
          companyProfile: data.companyProfile,
          expiresIn: COMPANY_SESSION_SECONDS,
          sessionType: "company",
          accessToken: data.token,
        };
        saveTokenInLocalStorage(sessionPayload);
        runLogoutTimer(dispatch, COMPANY_SESSION_SECONDS * 1000, navigate);
        dispatch(loginConfirmedAction(sessionPayload));
        navigate("/dashboard");
      } else {
        const errorMsg =
          data.pendingApproval && data.message
            ? data.message
            : "Los datos ingresados son incorrectos.";
        dispatch(loginFailedAction(errorMsg));
      }
    } catch (error) {
      const errorMessage = error.response?.data
        ? formatError(error.response.data)
        : "Error de conexión.";
      dispatch(loginFailedAction(errorMessage));
    }
  };
}

export function loginAffiliateAction(cuil, navigate) {
  return async (dispatch) => {
    try {
      const response = await loginAffiliateAuthentication(cuil);

      if (response.status === 200) {
        const { data } = response;
        const { token, employee } = data.data;

        const sessionPayload = {
          cuil,
          employee,
          idToken: token,
          accessToken: token,
          expiresIn: AFFILIATE_JWT_SECONDS,
          sessionType: "affiliate",
        };
        saveTokenAffiliateInLocalStorage(sessionPayload);
        runLogoutTimer(dispatch, AFFILIATE_JWT_SECONDS * 1000, navigate);
        dispatch(loginConfirmedAction(sessionPayload));
        if(employee.firstlog){
          navigate("/afiliado/");
        }else{
          navigate("/afiliado/edit-afiliado");
        }
       
      } else if (response.status === 400) {
        dispatch(loginFailedAction("Tu CUIL no es valido. Si no podes ingresar comunicate a <a href='mailto:afiliaciones@unioninformatica.org'>afiliaciones@unioninformatica.org  </a>"));
      } else {
        dispatch(loginFailedAction("Los datos ingresados son incorrectos."));
      }
    } catch (error) {
      const errorMessage = error.response?.data
        ? formatError(error.response.data)
        : "Error de conexión.";
      dispatch(loginFailedAction(errorMessage));
    }
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}
